import { Box, CardActions, Divider, Drawer, Typography } from '@mui/material'
import { Button, IconButton } from 'components'
import { useCreateParticularsComposition } from 'modules/orders/hooks'
import { MdKeyboardArrowLeft } from 'react-icons/md'
import { useItemFormDrawerStore } from '../ItemForm/itemFormDrawerStore'
import { useEffect, useMemo } from 'react'
import { ProductConfigurationForm } from './productConfigurationForm'
import { useForm, FormProvider } from 'react-hook-form'
import { Product } from 'modules/orders/types'
import { Yup } from 'utils'
import { yupResolver } from '@hookform/resolvers/yup'
import { createIdentifier } from './services/useCreateIdentifier'

const DRAWER_WIDTH = 530

type OnSuccessArgs = {
  configurationId: string
  formValues: unknown
  configurationDescription: string
}

type Props = {
  open: boolean
  onClose: () => void
  onSuccess: (data: OnSuccessArgs) => void
  formValues: any
  product: Product
  defaultValues?: any
}

export const ItemConfigurationDrawer = (props: Props) => {
  const { open, onClose, product, onSuccess, formValues, defaultValues } = props

  const setIsItemDrawerOpen = useItemFormDrawerStore.useSetIsDrawerOpen()

  const schema = useMemo(() => {
    const keys = Object.keys(defaultValues)

    const obj: any = {}

    keys.forEach((key: string) => {
      obj[key] = Yup.mixed().required()
    })

    return Yup.object(obj)
  }, [defaultValues])

  const methods = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues
  })

  const { formState } = methods
  const { errors } = formState

  const { handleSubmit, reset } = methods

  const {
    mutateAsync: createConfiguration,
    isLoading: isSubmittingConfiguration
  } = useCreateParticularsComposition()

  const isLoading = isSubmittingConfiguration
  const isError = !!Object.keys(errors).length
  // const handleReset = () => {
  //   reset()
  //   setResetDisableState((prev) => !prev)
  // }

  const handleBack = () => {
    onClose()
    setIsItemDrawerOpen(false)
  }

  const onSubmit = async (data: any) => {
    try {
      const formValues = JSON.parse(JSON.stringify(data))
      delete formValues.quantity

      // Reorganizar para ordem original usando originalIndex
      const particulars = product?.configuration?.particulars || []
      const reorderedFormValues: any = {}

      // Ordenar pelos índices originais
      const sortedByOriginalIndex = [...particulars].sort(
        (a: any, b: any) => a.originalIndex - b.originalIndex
      )

      // Criar objeto ordenado conforme ordem original
      sortedByOriginalIndex.forEach((particular: any) => {
        if (formValues[particular.id] !== undefined) {
          reorderedFormValues[particular.id] = formValues[particular.id]
        }
      })

      const particularComposition = await createIdentifier(reorderedFormValues)

      const response = await createConfiguration({ particularComposition })

      onSuccess({
        configurationId: response?.data?.id,
        configurationDescription: response?.data?.description,
        formValues: data
      })
    } catch (e) {
      console.log({ e })
      return e
    }
    onClose()
  }

  useEffect(() => {
    reset(formValues)
  }, [formValues, reset])

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      keepMounted
      variant="temporary"
      ModalProps={{
        onBackdropClick: () => {
          /* empty */
        }
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', sm: DRAWER_WIDTH },
          height: '100vh',
          backgroundColor: 'white',
          paddingBottom: 16
        }}
      >
        <div
          style={{
            position: 'sticky',
            top: 0,
            backgroundColor: 'white',
            padding: 12,
            zIndex: 97,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <IconButton onClick={handleBack}>
              <MdKeyboardArrowLeft
                size={24}
                color="#565656"
                style={{ background: '' }}
              />
            </IconButton>
            <div>
              <Typography
                variant="subtitle2"
                style={{
                  marginLeft: '1rem'
                }}
              >
                {product?.name || 'Sem nome'}
              </Typography>

              <Typography
                variant="caption"
                style={{
                  marginLeft: '1rem'
                }}
              >
                {product?.id} - {product?.reference}
              </Typography>
            </div>
          </div>
          <Divider />
        </div>

        <Typography
          variant="h6"
          style={{
            marginLeft: '1rem'
          }}
        >
          Configurador
        </Typography>

        <div style={{ padding: 12, paddingBottom: 100 }}>
          <FormProvider {...methods}>
            <ProductConfigurationForm
              configurations={product?.configuration?.particulars}
              configurationId={product?.configuration?.id}
              // resetDisableState={resetDisableState}
            />
          </FormProvider>
        </div>

        <div
          style={{
            position: `fixed`,
            width: DRAWER_WIDTH,
            bottom: 0,
            backgroundColor: 'white',
            zIndex: 99
          }}
        >
          <Divider />
          <CardActions
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: 16
            }}
          >
            <div>
              {/* <Button
                type="button"
                variant="text"
                color="error"
                onClick={handleReset}
              >
                Limpar Configuração
              </Button> */}
            </div>
            <div>
              <Button type="button" variant="text" onClick={handleBack}>
                Voltar
              </Button>
              <Button
                onClick={handleSubmit(onSubmit)}
                disabled={isLoading || isError}
              >
                Confirmar
              </Button>
            </div>
          </CardActions>
        </div>
      </Box>
    </Drawer>
  )
}
